import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthError } from '@azure/msal-browser';
import { ErrorTag } from 'src/app/common/enums/error-tag';
import { constants } from '../../../environments/constants';
import { environment } from '../../../environments/environment';
import { GoogleService } from '../login/google.service';
import { ApiError } from './common/api-error';
import { BaseApiService, FullUrlBuilder } from './common/base-api.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorsApiService extends BaseApiService {
  private pendingErrors: LoggableError[] = [];

  public constructor(httpClient: HttpClient) {
    super(httpClient);

    window.addEventListener('unload', () => {
      this.sendErrors();
    });
  }

  public insertDelayed(error: LoggableError): void {
    this.pendingErrors.push(error);
    window.setTimeout(() => {
      this.sendErrors();
    }, 500);
  }

  private insert(errors: readonly LoggableError[]): Promise<void> {
    if (environment.production) {
      const headers = new HttpHeaders({
        'App-Version': 'WebApp/' + constants.version + '_' + constants.gitVersion.hash,
        Authorization: 'Basic ' + btoa('bookker:bookker_bugs_123'),
      });
      return this._post<void>(FullUrlBuilder.create('https://develop.bookkercorp.com/apiBugReport/v1/reportBug'), errors, headers, false);
    } else {
      return Promise.resolve();
    }
  }

  private sendErrors(): void {
    if (this.pendingErrors.length !== 0) {
      this.insert(this.pendingErrors).catch(error => {
        console.warn('Error al guardar traza del error', error);
      });
      this.pendingErrors = [];
    }
  }
}

type LoggableErrorLevel = 'DEBUG' | 'INFO' | 'WARNING' | 'ERROR';

export class LoggableError {
  private static totalCount = 0;

  private readonly count: number;

  public constructor(
    private readonly error: Error,
    private readonly userEmail: string | null,
    private readonly level: LoggableErrorLevel,
    private readonly tag?: ErrorTag,
  ) {
    this.count = ++LoggableError.totalCount;
    if (tag == null) {
      this.tag = this.calculateTag(this.error);
    }
  }

  public toJSON(): object {
    return {
      email_user: this.userEmail,
      error_message: JSON.stringify({
        message: this.error.message,
        name: this.error.name,
        stack: this.error.stack,
        url: window.location.href,
        count: this.count,
      }),
      tag_error: this.tag,
      level: this.level,
      environment: environment.name,
    };
  }

  private calculateTag(error: unknown) {
    let tag: ErrorTag;
    if (error instanceof AuthError) {
      tag = ErrorTag.MSAL;
    } else if (GoogleService.isGoogleError(error)) {
      tag = ErrorTag.GOOGLE;
    } else if (error instanceof ApiError) {
      tag = ErrorTag.API;
    } else {
      tag = ErrorTag.WEBAPP;
    }
    return tag;
  }
}
